// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import PONumberState from "@store/Framework/Store/Greif/Pages/CheckoutShipping/PONumber/PONumberState";
import { PONumberParameter } from "@store/Framework/Store/Greif/Pages/CheckoutShipping/PONumber/PONumberTypes";
import { Draft } from "immer";

const initialState: PONumberState = {
    poNumber: "",
    isLoading: false,
};

const actions = {
    "Greif/Pages/CheckoutShipping/PONumber/BegingUpdate": (draft: Draft<PONumberState>) => {
        draft.isLoading = true;
    },
    "Greif/Pages/CheckoutShipping/PONumber/CompleteUpdate": (draft: Draft<PONumberState>) => {
        draft.isLoading = false;
    },
    "Greif/Pages/CheckoutShipping/PONumber/SetPONumber": (
        draft: Draft<PONumberState>,
        action: { parameter: PONumberParameter },
    ) => {
        draft.poNumber = action.parameter.poNumber;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifCheckoutShippingPagesReducerPONumberActions = Parameters<typeof reducer>[1];
export default reducer;
